// --- Multi-extension helpers ---
//
// Aceita TANTO o formato V2 legado (string com virgulas, ex.:
// ``"zip,xlsx"``) QUANTO o formato V3 (lista de strings, ex.:
// ``["zip", "xlsx"]``). Lista vazia / null / undefined sinaliza
// "nao restringir" (parser aceita qualquer formato).

const _normalize = (input) => {
  // V3: lista de strings.
  if (Array.isArray(input)) {
    return input.map((e) => String(e).trim().toLowerCase()).filter(Boolean);
  }
  // V2: string vazia ou comma-separated.
  if (typeof input === "string") {
    return input
      .toLowerCase()
      .split(",")
      .map((e) => e.trim())
      .filter(Boolean);
  }
  return [];
};

export const getAcceptExtensions = (expectedFileType) => {
  const list = _normalize(expectedFileType);
  if (list.length === 0) return undefined; // sem restricao no <input accept>
  // ``txt`` e ``csv`` se aceitam mutuamente (V2 legado).
  if (list.some((e) => e === "txt" || e === "csv")) {
    const expanded = new Set(list.map((e) => `.${e}`));
    expanded.add(".txt");
    expanded.add(".csv");
    return Array.from(expanded).join(",");
  }
  return list.map((e) => `.${e}`).join(",");
};

export const getAcceptExtensionsArray = (expectedFileType) => {
  const list = _normalize(expectedFileType);
  if (list.length === 0) return [];
  if (list.some((e) => e === "txt" || e === "csv")) {
    const expanded = new Set(list.map((e) => `.${e}`));
    expanded.add(".txt");
    expanded.add(".csv");
    return Array.from(expanded);
  }
  return list.map((e) => `.${e}`);
};

export const isExtensionValid = (fileExtension, expectedFileType) => {
  const accepted = _normalize(expectedFileType);
  if (accepted.length === 0) return true; // qualquer extensao
  return (
    accepted.includes(fileExtension) ||
    ((accepted.includes("txt") || accepted.includes("csv")) &&
      (fileExtension === "txt" || fileExtension === "csv"))
  );
};

export const formatFileTypeLabel = (expectedFileType) => {
  const list = _normalize(expectedFileType);
  if (list.length === 0) return "";
  return list.map((e) => `.${e}`).join(" / ");
};
